.trigger {
  height: 1px;
}
